import apiClient from './apiClient';
import { AccountsTransaction } from './roleWorkspaceService';

type Envelope<T> = { success?: boolean; data?: T; error?: string };

const unwrap = <T>(response: unknown): T => {
  const r = response as { data?: unknown; status?: number };
  const body = typeof r?.status === 'number' ? r.data : response;
  const env = body as Envelope<T>;
  return env && Object.prototype.hasOwnProperty.call(env, 'data')
    ? (env.data as T)
    : (body as T);
};

class AccountsTransactionService {
  async list(projectId: string): Promise<AccountsTransaction[]> {
    const response = await apiClient.get<Envelope<AccountsTransaction[]>>(`/accounts-transactions?project_id=${projectId}`);
    return unwrap<AccountsTransaction[]>(response) ?? [];
  }

  async create(input: {
    projectId: string;
    type: 'expense' | 'revenue' | 'adjustment';
    amount: number;
    transactionDate: string;
    description: string;
    taskId?: string;
    purchaseOrderId?: string;
    goodsReceiptId?: string;
    metadata?: Record<string, unknown>;
  }): Promise<AccountsTransaction> {
    const response = await apiClient.post<Envelope<AccountsTransaction>>('/accounts-transactions', input);
    return unwrap<AccountsTransaction>(response);
  }

  async record(id: string): Promise<AccountsTransaction> {
    const response = await apiClient.post<Envelope<AccountsTransaction>>(`/accounts-transactions/${id}/record`, {});
    return unwrap<AccountsTransaction>(response);
  }

  async reconcile(id: string): Promise<AccountsTransaction> {
    const response = await apiClient.post<Envelope<AccountsTransaction>>(`/accounts-transactions/${id}/reconcile`, {});
    return unwrap<AccountsTransaction>(response);
  }

  async reject(id: string, reason: string): Promise<AccountsTransaction> {
    const response = await apiClient.post<Envelope<AccountsTransaction>>(`/accounts-transactions/${id}/reject`, { reason });
    return unwrap<AccountsTransaction>(response);
  }
}

export default new AccountsTransactionService();
